import { render, staticRenderFns } from "./DefaultMailEditComplete.vue?vue&type=template&id=74b114fa&lang=pug&"
import script from "./DefaultMailEditComplete.vue?vue&type=script&lang=ts&"
export * from "./DefaultMailEditComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports